import { styled, TextField, IconButton, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSearchParams } from "react-router-dom";

const StyledTextField = styled(TextField)(({ theme }) => ({
  minWidth: 154,
  "& .MuiOutlinedInput-root": {
    height: 35,
    fontSize: "0.875rem",
    borderRadius: 3,
    backgroundColor: theme.palette.background.default,
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.05)",
  },
  "& .MuiInputLabel-root": {
    fontSize: "0.875rem",
    top: -8,
    "&.MuiInputLabel-shrink": {
      top: 0,
    },
  },
}));

const CustomDateRangeInput = ({ fromKey = "fromDate", toKey = "toDate" }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const fromValue = searchParams.get(fromKey) || "";
  const toValue = searchParams.get(toKey) || "";

  const handleChange = (key, value) => {
    const newParams = new URLSearchParams(searchParams);
    if (!value) {
      newParams.delete(key);
    } else {
      newParams.set(key, value);
    }
    setSearchParams(newParams);
  };

  const handleClear = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(fromKey);
    newParams.delete(toKey);
    setSearchParams(newParams);
  };

  const hasValue = fromValue || toValue;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <StyledTextField
        size="small"
        type="date"
        label="From Date"
        value={fromValue}
        onChange={(e) => handleChange(fromKey, e.target.value)}
        inputProps={{ max: toValue || undefined }}
        InputLabelProps={{ shrink: true }}
      />
      <StyledTextField
        size="small"
        type="date"
        label="To Date"
        value={toValue}
        onChange={(e) => handleChange(toKey, e.target.value)}
        inputProps={{ min: fromValue || undefined }}
        InputLabelProps={{ shrink: true }}
      />
      {hasValue && (
        <IconButton
          size="small"
          onClick={handleClear}
          title="Clear dates"
          sx={{ color: "text.secondary" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Stack>
  );
};

export default CustomDateRangeInput;
